import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Grid,
  Button,
  styled,
  ButtonProps,
  ButtonGroup,
  List,
  Stack,
  IconButton,
} from '@mui/material';
import { useState } from 'react';
import { Item, WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import DashboardGrid from './DashboardGrid';
import { SwipeableGuideOptions } from './SwipeableGuideOptions';

type ActiveStateProp = ButtonProps & {
  isActive: boolean;
};

const ListStep = styled(Button)(({ isActive }: ActiveStateProp) => ({
  color: isActive ? WsColors.TheBlues500 : WsColors.TheBlues100,
  textTransform: 'none',
  fontWeight: 'bold',
  ':hover': {
    backgroundColor: WsColors.TheBlues900,
  },
}));

const ListCircularButton = styled(Button)(({ isActive }: ActiveStateProp) => ({
  width: '40px',
  height: '40px',
  color: isActive ? WsColors.TheBlues900 : WsColors.TheBlues100,
  borderRadius: '100%',
  alignItems: 'center',
  marginRight: 25,
  fontWeight: 'bold',
  backgroundColor: isActive ? WsColors.TheBlues500 : WsColors.TheBlues900,
  ':hover': {
    backgroundColor: isActive ? WsColors.TheBlues500 : WsColors.TheBlues900,
  },
}));

const StyledButtonGroup = styled(ButtonGroup)({
  flexDirection: 'column',
  marginLeft: 20,
  marginTop: 10,
});

const UserGuide = () => {
  const listsArray = [
    'Post a new job',
    'Build your database',
    'Setup email account',
    'Configure Job Boards',
    'Real time VMS  Sync ',
    'Configure SMS Accounts',
    'Configure Calendar Account',
    'Set up Email Templates',
    'Chrome Extension ',
  ];
  const [selectedStep, setSelectedStep] = useState<number>(0);
  const [screenSize, setScreenSize] = useState<'small' | 'large'>('large');
  const content = (index: number) => setSelectedStep(index);
  return (
    <Grid container spacing={2}>
      {screenSize === 'large' && (
        <>
          <DashboardGrid
            item
            lg={3.3}
            md={3.85}
            sm={12}
            xs={12}
            bgcolor={WsColors.TheBlues900}
            sx={{
              ml: 2,
              overflow: 'auto',
              scrollbarWidth: 'thin',
              '&::-webkit-scrollbar': {
                width: '0.4em',
              },
            }}
            height={290}
          >
            <>
              <Item>
                <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.WHITE}>
                  Lets get you started
                </WsTypography>
                <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.PRIMARY600}>
                  To get the best experience out of the platform lets complete these basic steps
                </WsTypography>
              </Item>

              <StyledButtonGroup variant="text">
                {listsArray.map((listsArrayItem: string, index: number) => (
                  <List key={index}>
                    {index === selectedStep && (
                      <ListStep isActive onClick={() => content(index)}>
                        <ListCircularButton isActive>
                          {index < 9 && 0}
                          {index + 1}
                        </ListCircularButton>
                        {listsArrayItem}
                      </ListStep>
                    )}
                    {index != selectedStep && (
                      <ListStep isActive={false} onClick={() => content(index)}>
                        <ListCircularButton isActive={false}>
                          {index < 9 && 0}
                          {index + 1}
                        </ListCircularButton>
                        {listsArrayItem}
                      </ListStep>
                    )}
                  </List>
                ))}
              </StyledButtonGroup>
            </>
          </DashboardGrid>

          <DashboardGrid
            item
            lg={8.5}
            md={7.85}
            sm={12}
            xs={12}
            height={290}
            sx={{ bgcolor: WsColors.White }}
          >
            <Stack alignItems="end">
              <IconButton onClick={() => setScreenSize('small')}>
                <KeyboardArrowUpIcon />
              </IconButton>
            </Stack>
            <SwipeableGuideOptions onStepChange={setSelectedStep} />
          </DashboardGrid>
        </>
      )}
      {screenSize === 'small' && (
        <DashboardGrid
          item
          md={11.85}
          bgcolor={WsColors.TheBlues900}
          sx={{ cursor: 'pointer', ml: 2 }}
          onClick={() => setScreenSize('large')}
        >
          <Item>
            <WsTypography
              variant={WsTypoVariants.SUB_TITLE}
              color={WsTypoColors.WHITE}
              display="inline"
              onClick={() => setScreenSize('large')}
              cursor="pointer"
            >
              Lets get you started ...
            </WsTypography>
            <KeyboardArrowDownIcon
              onClick={() => setScreenSize('large')}
              sx={{ color: WsColors.White, float: 'right' }}
            />
          </Item>
        </DashboardGrid>
      )}
    </Grid>
  );
};
export default UserGuide;
